import type {WorkforceProfileAnalysisDataInput} from '../../types/workforceProfileDetailsTypes';
import type {WorkforceProfileWizardState} from '../../types/workforceProfileWizardTypes';

export const WORKFORCE_PROFILE_WIZARD_STORAGE_KEY = 'workforceProfileWizardDraft';

type WizardDraftPayload = {
  wizardState: WorkforceProfileWizardState;
  analysisInput: WorkforceProfileAnalysisDataInput;
};

export const createEmptyProfileAnalysisDataInput = (): WorkforceProfileAnalysisDataInput => ({
  extractionConfidence: null,
  candidateProfile: {
    summary: null,
    education: null,
    responsibilities: null,
    senioritySignals: null,
    industryExperience: null,
    workingStyleNotes: null,
  },
  skillsCompetencies: [],
  knowledgeSkills: [],
  workExperiences: [],
  languages: [],
  certifications: [],
  gapsOrAmbiguities: [],
});

export const createInitialWizardState = (defaultEmployerName = ''): WorkforceProfileWizardState => ({
  inputMode: null,
  setup: {
    departmentId: '',
    seniority: '',
    targetProfileId: '',
  },
  lookup: {
    personName: '',
    profileUrl: '',
    currentEmployerName: defaultEmployerName,
    currentJobTitle: '',
    location: '',
  },
  suggestedFieldKeys: [],
  researchCompleted: false,
});

export const persistWizardDraft = (
  companyId: string,
  wizardState: WorkforceProfileWizardState,
  analysisInput: WorkforceProfileAnalysisDataInput
) => {
  sessionStorage.setItem(
    `${WORKFORCE_PROFILE_WIZARD_STORAGE_KEY}:${companyId}`,
    JSON.stringify({wizardState, analysisInput})
  );
};

export const loadWizardDraft = (
  companyId: string
): WizardDraftPayload | null => {
  const raw = sessionStorage.getItem(`${WORKFORCE_PROFILE_WIZARD_STORAGE_KEY}:${companyId}`);
  if (!raw) {
    return null;
  }

  try {
    return JSON.parse(raw) as WizardDraftPayload;
  } catch {
    return null;
  }
};

export const clearWizardDraft = (companyId: string) => {
  sessionStorage.removeItem(`${WORKFORCE_PROFILE_WIZARD_STORAGE_KEY}:${companyId}`);
};
